export enum GeoImageTypeEnum {
	DRONE = 'DRONE',
	LIDAR = 'LIDAR',
	SATELITE = 'SATELITE',
	MDT = 'MDT',
}
